import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  // Start at 2h 47m 33s
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 47 * 60 + 33);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-red-700 text-white py-3 px-4 shadow-md" data-id="element-164">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 text-sm md:text-base font-bold text-center" data-id="element-165">
        <div className="flex items-center gap-2" data-id="element-166">
          <AlertTriangle className="w-5 h-5 text-yellow-300" data-id="element-167" />
          <span data-id="element-168">
            ATENCIÓN: Ebook + 4 Bonus GRATIS por solo $13.99 USD — Esta oferta
            termina en:
          </span>
        </div>
        <div className="bg-white/20 px-3 py-1 rounded font-mono tracking-wider" data-id="element-169">
          {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
        </div>
      </div>
    </div>;
}